'use client'

import React, { useEffect, useRef } from 'react'

import { chakra } from '@chakra-ui/react'

import { tableCheckboxStyles } from './Table.styles'
import { useTableColorScheme } from './TableContext'

export type TableCheckboxProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'type'
> & {
  /** When true, renders a dash (–) regardless of `checked`. */
  indeterminate?: boolean
}

export const TableCheckbox = ({
  indeterminate,
  ...props
}: TableCheckboxProps) => {
  const colorScheme = useTableColorScheme()
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate ?? false
    }
  }, [indeterminate])

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      inputRef.current?.click()
    }
    props.onKeyDown?.(e)
  }

  return (
    <chakra.input
      data-indeterminate={indeterminate ? '' : undefined}
      ref={inputRef}
      type='checkbox'
      {...tableCheckboxStyles(colorScheme)}
      {...props}
      onKeyDown={handleKeyDown}
    />
  )
}
